<template>
    <v-card-actions>
      <slot />
    </v-card-actions>
</template>

<script>
export default {
  name: "AppCardActions"
}
</script>
